import { useSyncExternalStore } from "react";
import {
  getPluginModelPickerServerSnapshot,
  getPluginModelPickerSnapshot,
  subscribePluginModelPicker,
} from "./pluginModelPicker";

export function usePluginModelPicker() {
  return useSyncExternalStore(
    subscribePluginModelPicker,
    getPluginModelPickerSnapshot,
    getPluginModelPickerServerSnapshot
  );
}
